import wNumb from 'wnumb/wNumb';

class CurrencyFormatter {
  static formatConfig = {
    decimals: 2,
    mark: ',',
    prefix: 'R$ ',
    thousand: '.',
  }

  constructor() {
    // eslint-disable-next-line no-underscore-dangle
    this._formatter = wNumb(CurrencyFormatter.formatConfig);
  }

  format(value) {
    if (this.isStringValue(value)) {
      // eslint-disable-next-line no-param-reassign
      value = parseFloat(value);
    }
    // eslint-disable-next-line no-underscore-dangle
    return this._formatter.to(value);
  }

  isStringValue(value) {
    return typeof value === 'string';
  }
}

export default new CurrencyFormatter();
